import { apiProxyRequest } from "Api/apiProxyRequest";

import type {
  BillingProfileAddons,
  BillingProfileAddonsUpdatePayload
} from "../types";

export const updateProfileAddonsRequest = (
  billingProfileId: string,
  payload: BillingProfileAddonsUpdatePayload
) =>
  apiProxyRequest<BillingProfileAddons>(
    `/billing/profiles/${billingProfileId}/addons`,
    "PATCH",
    payload
  );
